// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diyStore[data-v-a6a635ec] {\n  background: #fff;\n}\n.pictrue[data-v-a6a635ec] {\n  margin-right: 6px !important;\n}\n.mr6[data-v-a6a635ec] {\n  margin-right: 8px !important;\n}\n.icon-pingfen[data-v-a6a635ec] {\n  font-size: 11px !important;\n}", ""]);
// Exports
module.exports = exports;
